/* ================================================== */
/* FUNCTIONS
/* ================================================== */

function checkDeviceType(){
  if ($(window).width() < 767) {
    $('body').addClass('mobile tablet');
  } else {
    $('body').removeClass('mobile tablet');
  }
}

function checkDeviceOrientation(){
  $('body').removeClass('deviceOrientation--landscape deviceOrientation--portrait');

  if ($('body').hasClass('mobile tablet')) {
    if(window.innerWidth > window.innerHeight){
      $('body').addClass('deviceOrientation--landscape');
    } else {
      $('body').addClass('deviceOrientation--portrait');
    }
  }
}

function actionDropdownMenu(){
  $('.dropdown-toggle').on('click', function(e){
    e.preventDefault();
    $(this).parents('.dropdown').toggleClass('show');
  });
}


/* ================================================== */
/* DOCUMENT READY
/* ================================================== */

$(document).ready(function(){

	checkDeviceOrientation();
  
  actionDropdownMenu();

});



/* ================================================== */
/* WINDOW RESIZE & ORIENTATIONCHANGE
/* ================================================== */

$(window).on('resize orientationchange', function(){
	
	checkDeviceType();
  checkDeviceOrientation();

});